import SystemService from '../services/SystemService';
import CollectorService from '../services/CollectorService';
import Common from './common'
import Vue from 'vue'
import _ from 'lodash'

const SUCCESS_NOTIF_TIMEOUT = 4000
const ERROR_NOTIF_TIMEOUT = 0

function copyDocSchedules(source, target) {
    target.splice(0, target.length, ...source)
}

function copySystemSchedulingInfo(source, target) {
    target.rtEnabled = source.rtEnabled
    // target.rtDetailEnabled = source.rtDetailEnabled
    //target.rtKeyFrameIntervalSeconds = source.rtKeyFrameIntervalSeconds
//    target.rtDetailRefreshIntervalSeconds = source.rtDetailRefreshIntervalSeconds
    target.rtPollIntervalMs = source.rtPollIntervalMs
    // target.rtMaxDelaySeconds = source.rtMaxDelaySeconds

    if (target.configs) {
        _.each(_.keys(target.configs), key => {
            if (key.includes('.poll.schedule')) {
                delete target.configs[key]
            }
        })
    }

    if (source.configs) {
        target = target || {}
        target.configs = target.configs || {}

        _.each(_.keys(source.configs), key => {
            if (key.includes('.poll.schedule')) {
                target.configs[key] = source.configs[key]
            }
        })
    }
}

function setDefaultValuesInDES(sections) {

    _.each(sections, (section) => {
        if (_.isEmpty(section.properties)) {
            return
        }
        _.each(section.properties, (prop) => {
            if (_.isNil(prop.value) && !_.isNil(prop.defaultValue)) {
                if ((prop.type !== "link") && (!prop.defaultValue.includes || !prop.defaultValue.includes('eval:'))) {
                    prop.value = prop.defaultValue
                }
            }
            if (_.isNil(prop.value) && _.isNil(prop.defaultValue) && (prop.dataType === 'string')) {
                prop.value = "";
            }
        })
    })
}

function copyDataEntrySection(source, target) {
    if (target.properties && target.properties.length) {
        target.properties.splice(0, target.properties.length, ...source.properties)
    }
}

function copySystemInfo(source, target) {
    target.name = source.name
    target.description = source.description
    target.id = source.id
}

function getSectionPropValues(dataEntrySections) {
    let result = _.flatMap(dataEntrySections, (section) => { return _.map(section.properties, prop => ({sectionId: section.id, fieldName: prop.fieldName, fieldValue: prop.value, fieldType: prop.type})) })
    return _.filter(result, (item) => { return item.fieldType !== 'label'})
}

function updateSchedules(docSchedules, sysconfigs) {

    _.each(docSchedules, (ds) => {
        if (!ds.pollSchedule || (!ds.pollSchedule.includes('I'))) {
            return
        }
        let tokens = ds.pollSchedule.split('I')
        let hr = tokens[0] || '0000'
        ds.polltime = hr[0]+hr[1]+':'+hr[2]+hr[3]
        ds.interval = tokens[1]
        ds.enabled = ds.pollSchedule === 'I0' ? false : sysconfigs[ds.docType.code + '.poll.schedule']!=='skip'
    })
}

function updateConfigsFromSchedules(schedules, system) {

    _.each(schedules, (ds) => {
        if (ds.polltime && ds.interval) {
            ds.pollSchedule = ds.polltime.replace(':','') + 'I' + ds.interval
        }
        if (!ds.enabled) {
            system.configs[ds.docType.code + '.poll.schedule'] = 'skip'
        } else {
            delete system.configs[ds.docType.code + '.poll.schedule']
        }
    })
}

function sanitize(value) {
    return value && (typeof value === 'string') ? value.replace(';', '%3B') : value
}

function copyIntoConfigsFromSection(configs, sectionProperties, ignoreNulls) {

    _.forEach(sectionProperties, prop => {
        if (!ignoreNulls || (ignoreNulls && (!_.isUndefined(prop.value) && !_.isNull(prop.value)))) {
            configs[prop.fieldName] = sanitize(prop.value)
        }

        if ((prop.readonly === true) || prop.readonlyEx) {
            delete configs[prop.fieldName]
        }
    })
}

function copyIntoConfigsFromSections(configs, sections) {
    _.forEach(sections, (section) => {
        copyIntoConfigsFromSection(configs, section.properties)
    })
}

function getLogoImage(item) {
    let imgUrl = '20x20-cisco.png'
    let imgUrl250 = '250x250-cisco.png'
    switch(item.code || item.type){
      case "OEOM": imgUrl = '20x20-oracle.png'; imgUrl250 = '250x250-oracle-OEOM.png'; break;
      case "OSBC": imgUrl = '20x20-oracle.png'; imgUrl250 = '250x250-oracle-SBC.png'; break;
      case "AURASM": imgUrl = '20x20-avaya.png'; imgUrl250 = '250x250-avaya.png'; break;
      case "ACANO": case "CMS": imgUrl = '20x20-cms.png'; imgUrl250 = '250x250-cms.png'; break;
      case "BJN": imgUrl = '20x20-bluejeans.png'; imgUrl250 = '250x250-bluejeans.png'; break;
      case "CHIME": imgUrl = '20x20-amazonChime.png'; imgUrl250 = '250x250-AmazonChime.png'; break;
      case "CSPRK": case "CISCOWEBEX": case "CISCOCH": imgUrl250 = '250x250-cisco-webex.png'; break;
      case "CUBE": imgUrl = '20x20-cube.png'; imgUrl250 = '250x250-cube.png'; break;
      case "CUSTOM": case "CSV": case "CUSTOMCLOUD": imgUrl = '20x20-csv.png'; imgUrl250 = '250x250-csv.png'; break;
      case "DMA": case "RPRM": case "RMX": case "RPAD": case "POLYLENS": imgUrl = '20x20-poly.png'; imgUrl250 = '250x250-poly.png';  break;
      case "EPDOCS": imgUrl = '20x20-epdocs.png'; imgUrl250 = '250x250-epdocs.png';  break;
      case "EXCHG": imgUrl = '20x20-ms-exch.png'; imgUrl250 = '250x250-MSExch.png'; break;
      case "GCAL": imgUrl = '20x20-gcal.png'; imgUrl250 = '250x250-gcal.png'; break;
      case "GOTO": imgUrl = '20x20-gmeet.png'; imgUrl250 = '250x250-gmeet.png'; break;
      case "GMEET": imgUrl = '20x20-gmeet.png'; imgUrl250 = '250x250-gmeet.png'; break;
      case "ISDN": imgUrl = 'isdn.jpg'; imgUrl250 = 'isdn.jpg'; break;
      case "KONTAKT": imgUrl = '20x20-kontakt.png'; imgUrl250 = '250x250-kontakt.png'; break;
      case "LOGISYNC": imgUrl = '20x20-logitech-sync.png'; imgUrl250 = '250x250-logitech.png'; break;
      case "MSTEAMS": imgUrl = '20x20-ms-teams.png'; imgUrl250 = '250x250-ms-teams.png'; break;
      case "NEATPULSE": imgUrl = '20x20-neat.png'; imgUrl250 = '250x250-neat.png';  break;
      case "OFFICE365": imgUrl = '20x20-off365.png'; imgUrl250 = '250x250-Office365.png'; break;
      case "PEXIP": case "PEXIPERM": imgUrl = '20x20-pexip.png'; imgUrl250 = '250x250-pexip.png'; break;
      case "RINGCENTRAL": imgUrl = '20x20-ringcentral.png'; imgUrl250 = '250x250-RingCentral.png'; break;
      case "SKYPE": case "LYNC": imgUrl = 'skype.png'; imgUrl250 = 'skype.png'; break;
      case "VIDYO": imgUrl = 'vidyo.png'; imgUrl250 = 'vidyo.png'; break;
      case "WEBEX": case "WEBEX (legacy)": imgUrl250 = '250x250-webex-legacy.png'; break;
      case "ZOOM": case "ZOOMPHONE": imgUrl = 'zoom.png'; imgUrl250 = '250x250-zoom.png'; break;
      default: break;
    }
    return {imgUrl: 'dist/images/systems/' + imgUrl, imgUrl250: 'dist/images/systems/' + imgUrl250}
}

const state = {
    systems: [],
    activeSystemOriginal: {},
    activeSystem: {},
    activeSystemDocumentSchedules: [],
    activeSystemDocumentSchedulesOriginal: [],
    activeSystemDataEntrySections: [],
    activeSystemDataEntrySectionsOriginal: [],
    typeCodes: [],
    allTypeCodes: [],
    activeSystemOrgLevelConfigs: null,
    activeSystemOrgLevelConfigsOriginal: null,
    pagination: {
        rowsPerPage: 10,
        sortBy: ["type.name"],
        descending: false,
        page: 1,
        totalItems: 0,
        stored: true
    }
}
const getters = {
    activeSystem(state) { return this.activeSystem },
    activeSystemOriginal(state) { return state.activeSystemOriginal },
    activeSystemDocumentSchedules(state) {
        return state.activeSystemDocumentSchedules
    },
    activeSystemDataEntrySections(state) { return _.filter(state.activeSystemDataEntrySections, (section) => { return _.some(section.properties, (prop) => { return prop.visible && (prop.visible !== 'never') } ) }) },
    activeSystemDataEntrySectionsOriginal(state) { return state.activeSystemDataEntrySectionsOriginal; },
    activeSystemDataEntrySectionOriginal: (state)=>(sectionId)=> {
        return _.find(state.activeSystemDataEntrySectionsOriginal, { id : sectionId })
    },
    activeSystemDataEntrySection: (state)=>(sectionId)=> {
        return _.find(state.activeSystemDataEntrySections, { id : sectionId })
    },
    activeSystemAppSection: (state) => {
        return _.find(state.activeSystemDataEntrySections, { id : 'app' })
    },
    activeSystemNonAppSections: (state) => {
        return _.filter(state.activeSystemDataEntrySections, (section) => { return section.id !== 'app' })
    },
    supportedSystems: (state) =>{
        let codes = _.map(state.typeCodes, 'code')
        return _.filter(state.systems, (sys) => {
            return codes.includes(sys.type.code)
        })
    },
    allSystems: (state) => {
        return state.systems
    },
    allTypeCodes: (state) => {
        return state.allTypeCodes
    },
    // typeCodes: (state) => {
    //     return _.map(state.typeCodes, 'code')
    // },
    activeSystemOrgLevelConfigs: (state) => {
        return state.activeSystemOrgLevelConfigs
    },
    activeSystemOrgLevelConfigSection: (state)=>(sectionId)=> {
        return _.find(state.activeSystemOrgLevelConfigs, { id : sectionId })
    },
    activeSystemOrgLevelConfigsOriginal: (state) => (sectionId) => {
        return _.find(state.activeSystemOrgLevelConfigsOriginal, { id : sectionId })
    },
    hasSystemsAssignedToCa: state => userId => {
        return state.systems && _.find(state.systems, {ccaId: userId})
    },
    allEnabledCloudSystemIds: (state) => {
        if (!state.systems) {
            return []
        }
        return _.map(_.filter(state.systems, {isCloudSystem: true, pollEnabled: true}), 'id')
    },
    getPagination: (state) => {
        return state.pagination
    }
}

const mutations = {
    initialize(state) {
        Vue.set(state, 'systems', [])
        Vue.set(state, 'typeCodes', [])
        Vue.set(state, 'pagination', {stored: true, rowsPerPage: 10,sortBy: ["type.name"],descending: false, page: 1, totalItems: 0})
        mutations.initializeActiveSystem(state)
    },
    initializeActiveSystem(state) {
        Vue.set(state, 'activeSystem', {})
        Vue.set(state, 'activeSystemOriginal', {})
        Vue.set(state, 'activeSystemDocumentSchedules', [])
        Vue.set(state, 'activeSystemDocumentSchedulesOriginal', [])
        Vue.set(state, 'activeSystemDataEntrySections', [])
        Vue.set(state, 'activeSystemDataEntrySectionsOriginal', []),
        Vue.set(state, 'activeSystemOrgLevelConfigs', null)
        Vue.set(state, 'activeSystemOrgLevelConfigsOriginal', null)
    },
    setPagination(state, pagination) {
        Vue.set(state, 'pagination', pagination)
    },
    setTypeCodes(state, typeCodes) {
        Vue.set(state, 'typeCodes', typeCodes)
    },
    setSystems(state, systems) {
      Vue.set(state, 'systems', systems)
    },
    setAllTypeCodes(state, typeCodes) {
        Vue.set(state, 'allTypeCodes', typeCodes)
    },
    setActiveSystem(state, system) {
        Vue.set(state, 'activeSystem', system)
    },
    setActiveSystemOriginal(state, system) {
        Vue.set(state, 'activeSystemOriginal', system)
    },
    setActiveSystemDocumentSchedules(state, docSchedules) {
        Vue.set(state, 'activeSystemDocumentSchedules', docSchedules)
    },
    setActiveSystemDocumentSchedulesOriginal(state, docSchedules) {
        Vue.set(state, 'activeSystemDocumentSchedulesOriginal', docSchedules)
    },
    setActiveSystemDataEntrySections(state, sections) {
        Vue.set(state, 'activeSystemDataEntrySections', sections)
    },
    setActiveSystemDataEntrySectionsOriginal(state, sections) {
        Vue.set(state, 'activeSystemDataEntrySectionsOriginal', sections)
    },
    resetActiveSystemDocSchedules(state) {
        let source = Common.deepcopy(state.activeSystemDocumentSchedulesOriginal)
        let target = state.activeSystemDocumentSchedules

        copyDocSchedules(source, target)
    },
    applyActiveSystemDocSchedules(state) {
        let source = Common.deepcopy(state.activeSystemDocumentSchedules)
        let target = state.activeSystemDocumentSchedulesOriginal

        copyDocSchedules(source, target)
    },
    resetActiveSystemSchedulingInfo(state) {
        let source = state.activeSystemOriginal
        let target = state.activeSystem

        copySystemSchedulingInfo(source, target)
    },
    applyActiveSystemSchedulingInfo(state) {
        let source = state.activeSystem
        let target = state.activeSystemOriginal

        updateConfigsFromSchedules(state.activeSystemDocumentSchedules, state.activeSystem)

        copySystemSchedulingInfo(source, target)
    },
    resetActiveSystemDataEntrySection(state, sectionId) {

        let source = Common.deepcopy(getters.activeSystemDataEntrySectionOriginal(state)(sectionId))
        let target = getters.activeSystemDataEntrySection(state)(sectionId)

        copyDataEntrySection(source, target)
    },
    applyActiveSystemDataEntrySection(state, sectionId) {

        let source = Common.deepcopy(getters.activeSystemDataEntrySection(state)(sectionId))
        let target = getters.activeSystemDataEntrySectionOriginal(state)(sectionId)

        copyDataEntrySection(source, target)
    },
    resetActiveSystemInfo(state) {
        let source = state.activeSystemOriginal
        let target = state.activeSystem

        copySystemInfo(source, target)
    },
    applyActiveSystemInfo(state, updatedSystem) {
        let source = state.activeSystem
        source.id = updatedSystem.id

        let target = state.activeSystemOriginal

        copySystemInfo(source, target)
    },
    setNewVersion(state, version) {
        state.activeSystem.olv = version
        state.activeSystemOriginal.olv = version
    },
    toggleEnabled(state) {
        state.activeSystemOriginal.pollEnabled = state.activeSystem.pollEnabled
    },
    setActiveSystemOrgLevelConfigs(state, configs) {
        Vue.set(state, 'activeSystemOrgLevelConfigs', configs)
    },
    setActiveSystemOrgLevelConfigsOriginal(state, configs) {
        Vue.set(state, 'activeSystemOrgLevelConfigsOriginal', configs)
    },
    resetActiveSystemOrgLevelConfigs(state, sectionId) {

        let source = Common.deepcopy(getters.activeSystemOrgLevelConfigsOriginal(state)(sectionId))
        let target = getters.activeSystemOrgLevelConfigSection(state)(sectionId)

        copyDataEntrySection(source, target)
    },
    applyActiveSystemOrgLevelConfigs(state, sectionId) {

        let source = Common.deepcopy(getters.activeSystemOrgLevelConfigSection(state)(sectionId))
        let target = getters.activeSystemOrgLevelConfigsOriginal(state)(sectionId)

        copyDataEntrySection(source, target)
    },
    applyActiveSystemCcaId(state, ccaId) {
        state.activeSystem.ccaId = ccaId
        state.activeSystemOriginal.ccaId = ccaId
    },
    resetActiveSystemCcaId(state) {
        state.activeSystem.ccaId = state.activeSystemOriginal.ccaId
    }
}

function setDriverDataInSchedules(drivers, schedules) {

    if (!_.isEmpty(drivers) && _.isArray(drivers)) {
        if (_.isArray(drivers)) {
            _.forEach(schedules, (schedule) => {
                schedule.driver = _.find(drivers, {documentType: schedule.docType.code})
            })
        }
    }
}

const actions = {
    initialize ({commit}) {
        commit('initialize')
    },
    setPagination({commit}, pagination) {
        commit('setPagination', pagination)
    },
    async getAllSystems({ commit, rootGetters, dispatch }) {
        let response

        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Fetching infrastructure"}, {root: true})

            commit('initializeActiveSystem')
            commit('setSystems', [])

            response = await SystemService.getSystems(false)

            let stauses = []

            const modules = rootGetters['user/getModulesDictionary']
            if (modules && modules.Assurance) {
                let statusResponse = await SystemService.getSystemStatuses()
                stauses = statusResponse.data || []
            }

            await dispatch('user/loadUsersIfNotLoaded', {}, {root: true})

            let systems = _.each(response.data, (item) => {
                let imgs = getLogoImage(item)
                item.logo = imgs.imgUrl
                item.logo250 = imgs.imgUrl250
                item.ccaUser = ''
                if (item.ccaId) {
                    const ccaUser = rootGetters['user/findUser'](item.ccaId)
                    if (ccaUser) {
                        item.ccaUser = ccaUser.login
                    }
                }
                let status = _.find(stauses, {system_id: item.id})
                if (status) {
                    item.status = status.status
                    item.statusTime = status.time
                }
            })
            commit('setSystems', systems)

            dispatch('status/setStatus', {inProgress: false, operation: "Infrastructure refreshed", success: true, logAction: 'listing-systems'}, {root: true})
        } catch (ex) {
            console.error(ex)
            dispatch('status/setStatus', {inProgress: false, operation: "Error fetching infrastructure", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-listing-systems'}, {root: true})
            return
        }
    },
    async loadSystemsIfNotLoaded({state, dispatch}) {
        if (state.systems && state.systems.length) {
            return
        }
        return dispatch('getAllSystems')
    },
    async getSystemSchedules({ commit, rootGetters, dispatch, state }, {id, sysConfigs, forceDriverRefresh, isCloudSystem}) {

        let docSchedules = await SystemService.getDocSchedules(id)

        updateSchedules(docSchedules.data, sysConfigs)

        let schedules = docSchedules.data
        if (schedules && !_.isEmpty(schedules)) {
            if (forceDriverRefresh) {
                if (isCloudSystem) {
                    await dispatch('collectors/getCloudDrivers', forceDriverRefresh, {root: true})
                } else {
                    await dispatch('collectors/getDrivers', forceDriverRefresh, {root: true})
                }
            }
            let drivers = isCloudSystem ? rootGetters['collectors/getCloudDrivers'] : rootGetters['collectors/getDrivers']
            setDriverDataInSchedules(drivers, schedules)
        }

        commit('setActiveSystemDocumentSchedules', schedules)

        let originalSchedules = Common.deepcopy(schedules)
        commit('setActiveSystemDocumentSchedulesOriginal', originalSchedules)

        return schedules
    },
    async getSystem({ state, commit, rootState, rootGetters, dispatch }, id) {
        let sysDetails
        let sysSections

        try {
            if (dispatch) {
                dispatch('status/setStatus', {inProgress: true, operation: "Fetching infrastructure details"}, {root: true})
            }

            commit('initializeActiveSystem')

            sysDetails = await SystemService.getSystem(id)
            let imgs = getLogoImage(sysDetails.data)
            sysDetails.data.logo = imgs.imgUrl
            sysDetails.data.logo250 = imgs.imgUrl250
            let schedules = await actions.getSystemSchedules({ commit, rootGetters, dispatch, state }, {id, sysConfigs: sysDetails.data.configs})

            sysDetails.data.hasDriver = !_.isEmpty(_.find(schedules, (item) => { return !!item.driver }))

            commit('setActiveSystem', sysDetails.data)

            sysSections = await SystemService.getSystemDataEntrySections(id)

            setDefaultValuesInDES(sysSections.data)

            commit('setActiveSystemDataEntrySections', sysSections.data)

            let originalCopy = Common.deepcopy(sysDetails.data);
            commit('setActiveSystemOriginal', originalCopy);

            let originalDES = Common.deepcopy(sysSections.data);
            commit('setActiveSystemDataEntrySectionsOriginal', originalDES);

            let orgLevelConfigs = await SystemService.getOrgLevelConfigs(sysDetails.data.type.code)
            setDefaultValuesInDES(orgLevelConfigs.data)
            commit('setActiveSystemOrgLevelConfigs', orgLevelConfigs.data)
            commit('setActiveSystemOrgLevelConfigsOriginal', Common.deepcopy(orgLevelConfigs.data))

            if (dispatch) {
                dispatch('status/setStatus', {inProgress: false, operation: "Infrastructure details loaded", success: true, logAction: 'getting-system-details'}, {root: true})
            }
        } catch (ex) {
            console.error(ex)
            if (dispatch) {
                dispatch('status/setStatus', {inProgress: false, operation: "Error fetching infrastructure details", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-getting-system-details'}, {root: true})
            }
            // Handle error
            return
        }
    },
    async getTypeCodes ({ state, commit, rootState, rootGetters, dispatch }) {
        let response

        try {
            response = await SystemService.getTypeCodes()

            let typecodes = _.each(response.data, (item) => {
                let imgs = getLogoImage({type: item.code || item.name})
                item.logo = imgs.imgUrl
                item.logo250 = imgs.imgUrl250
            })

            typecodes.sort(function(a, b) {
                var nameA = a.name.toLowerCase(); // ignore upper and lowercase
                var nameB = b.name.toLowerCase(); // ignore upper and lowercase
                if (nameB.includes('beta') && !nameA.includes('beta') ) {
                    return -1;
                }
                if (nameA.includes('beta') && !nameB.includes('beta')) {
                    return 1;
                }
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }

                return 0;
            });

            commit('setTypeCodes', typecodes)
        } catch (ex) {
            dispatch('status/setStatus', {inProgress: false, operation: "Error fetching infrastructure types", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-getting-typecodes'}, {root: true})
            return
        }
    },
    async setupNewSystem({ state, commit, rootState, rootGetters }, typecode) {
        commit('initializeActiveSystem')

        let sysDetails = await SystemService.getNewSystem(typecode.code)
        let imgs = getLogoImage(sysDetails.data)
        sysDetails.data.logo = imgs.imgUrl
        sysDetails.data.logo250 = imgs.imgUrl250
        commit('setActiveSystem', sysDetails.data)

        let originalCopy = Common.deepcopy(sysDetails.data);

        let sysSections = await SystemService.getDataEntrySectionsForTypeCode(typecode.code)
        commit('setActiveSystemDataEntrySections', sysSections.data)

        let docSchedules = await SystemService.getDocSchedulesForTypeCode(typecode.code)

        updateSchedules(docSchedules.data, sysDetails.data.configs)

        commit('setActiveSystemDocumentSchedules', docSchedules.data)

        setDefaultValuesInDES(sysSections.data)

        let originalDES = Common.deepcopy(sysSections.data);
        commit('setActiveSystemDataEntrySectionsOriginal', originalDES);

        //originalCopy.dataEntrySections = originalDES
        commit('setActiveSystemOriginal', originalCopy);

        let originalSchedules = Common.deepcopy(docSchedules.data)
        commit('setActiveSystemDocumentSchedulesOriginal', originalSchedules)

    },
    async resetActiveSystemInfo({ state, commit, rootState }) {
        commit('resetActiveSystemInfo')
    },
    async resetActiveSystemSchedules({ state, commit, rootState }) {
        commit('resetActiveSystemDocSchedules')
        commit('resetActiveSystemSchedulingInfo')
    },
    async resetActiveSystemDataEntrySection({ state, commit, rootState }, {sectionId, systemInfo}) {
        if (sectionId === "app") {
            commit('resetActiveSystemInfo')
        }
        commit('resetActiveSystemDataEntrySection', sectionId)
    },
    async resetActiveSystemOrgLevelConfigs({ state, commit, rootState }, sectionId) {
        commit('resetActiveSystemOrgLevelConfigs', sectionId)
    },
    async deleteSystem({commit, rootGetters, dispatch}, system) {
        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Deleting infrastructure"}, {root: true})
            system.deleted = true
            let response = await SystemService.deleteSystem(system.id) //, rootGetters['user/getSessionId'], rootGetters['user/getOrgContext'] || rootGetters['user/getOrgId'], rootGetters['user/getUserId'])
            if (response && response.status === 200) {
                commit('setNewVersion', response.data.olv)
                dispatch('status/setStatus', {inProgress: false, operation: "Infrastructure deleted", success: true, logAction: 'deleting-system'}, {root: true})
                await dispatch('getAllSystems')
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error deleting infrastructure", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-deleting-system'}, {root: true})
            }
        } catch (ex) {
            dispatch('status/setStatus', {inProgress: false, operation: "Error deleting infrastructure", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-deleting-system'}, {root: true})
            alert('Error deleting infrastructure ' + Common.getErrorMessage(ex))
        }
    },
    async saveActiveSystemSchedules({ state, commit, rootState, rootGetters, dispatch }) {
        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Saving infrastructure schedule changes"}, {root: true})

            let sourceSystem = state.activeSystem
            let targetSystem = Common.deepcopy(state.activeSystemOriginal)
            copySystemSchedulingInfo(sourceSystem, targetSystem)
            copyIntoConfigsFromSections(targetSystem.configs, state.activeSystemDataEntrySectionsOriginal)

            if (!targetSystem.supportsRealtime) {
                delete targetSystem.rtEnabled
                delete targetSystem.rtPollIntervalMs
//                delete targetSystem.rtDetailRefreshIntervalSeconds
            }

            updateConfigsFromSchedules(state.activeSystemDocumentSchedules, targetSystem)

            //other values may have changed due to binding, so get a clean version
            //and copy only relevant pieces of information

            let sourceSchedules = state.activeSystemDocumentSchedules
            let targetSchedules = Common.deepcopy(state.activeSystemDocumentSchedulesOriginal)
            copyDocSchedules(sourceSchedules, targetSchedules)

            //attempt to save the changes
            let responseSystem = await SystemService.saveSystem(targetSystem, false)

            let patchList = _.map(targetSchedules, (schedule) => { return { id: schedule.id, pollSchedule: schedule.pollSchedule } })

            let responseSchedules = await SystemService.saveDocSchedulesForSystemId(targetSystem.id, patchList)

            if (responseSystem && (responseSystem.status === 200)) {
                commit('setNewVersion', responseSystem.data.olv)
            }

            //if successful, update the original version, otherwise nothing needs to be done
            //because the original version is intact
            if (responseSystem && (responseSystem.status === 200) && responseSchedules && (responseSchedules.status === 200)) {
                commit('applyActiveSystemSchedulingInfo')
                commit('applyActiveSystemDocSchedules')
                dispatch('status/setStatus', {inProgress: false, operation: "Infrastructure schedule changes saved", success: true, logAction: 'saving-system-schedule'}, {root: true})
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error saving infrastructure schedule changes", failure: true, message: responseSchedules.statusText, logAction: 'error-saving-system-schedule'}, {root: true})
            }

        } catch (ex) {
            dispatch('status/setStatus', {inProgress: false, operation: "Error saving infrastructure schedule changes", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-saving-system-schedule'}, {root: true})
            alert('Error saving infrastructure schedule changes ' + Common.getErrorMessage(ex))
        }
    },
    resetActiveSystemCcaId({commit}){
        commit('resetActiveSystemCcaId')
    },
    async saveActiveSystemCcaId({state, commit, dispatch}) {

        dispatch('status/setStatus', {inProgress: true, operation: "Saving infrastructure configuration changes"}, {root: true})

        let sourceSystem = state.activeSystem
        let targetSystem = Common.deepcopy(state.activeSystemOriginal)
        targetSystem.ccaId = sourceSystem.ccaId
        copyIntoConfigsFromSections(targetSystem.configs, state.activeSystemDataEntrySectionsOriginal)

        try {
            //attempt to save the changes
            let responseSystem = await SystemService.saveSystem(targetSystem, false)

            if (responseSystem && (responseSystem.status === 200)) {
                commit('setNewVersion', responseSystem.data.olv)
                commit('applyActiveSystemCcaId', responseSystem.data.ccaId)
                dispatch('status/setStatus', {inProgress: false, operation: "Infrastructure configuration changes saved", success: true, logAction: 'saving-system-cca-id'}, {root: true})
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error saving infrastructure configuration changes", failure: true, message: responseSchedules.statusText, logAction: 'error-saving-system-cca-id'}, {root: true})
            }
        } catch (ex) {
            dispatch('status/setStatus', {inProgress: false, operation: "Error saving infrastructure configuration changes", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-saving-system-cca-id'}, {root: true})
            alert('Error saving infrastructure configuration changes ' + Common.getErrorMessage(ex))
        }
    },
    async saveActiveSystemDataEntrySection({ state, commit, rootState, rootGetters, dispatch }, {sectionId, systemInfo}) {

        let activeSection = getters.activeSystemDataEntrySection(state)(sectionId)

        if (sectionId === 'app') {
            const newHostItem = _.find(activeSection.properties, {fieldName: 'host'})
            if (newHostItem) {
                const newhost = _.trim(newHostItem.value)

                const dupHost = _.find(state.systems, (sys) => {
                    return (sys.id !== state.activeSystem.id) && (sys.hostWithoutPort === newhost)
                })
                if (dupHost) {
                    if (!confirm("Host " + newhost + " is used for another infrastructure " + dupHost.name + ". Continue saving?")) {
                        return false
                    }
                }
                newHostItem.value = newhost; //trimmed value
            }
        }

        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Saving system configuration changes"}, {root: true})

            //other values may have changed due to binding, so get a clean version
            //and copy only relevant pieces of information

            let target = Common.deepcopy(state.activeSystemOriginal)

            let chgpwd = false
            if (sectionId === 'app') {
                copySystemInfo(state.activeSystem, target)

                let activeSectionOriginal = getters.activeSystemDataEntrySectionOriginal(state)(sectionId)

                let newpwdItem = _.find(activeSection.properties, {fieldName: 'password'})
                if (newpwdItem) {
                    let newpwd = newpwdItem.value

                    let oldpwdItem = _.find(activeSectionOriginal.properties, {fieldName: 'password'})
                    let oldpwd = oldpwdItem ? oldpwdItem.value : null

                    chgpwd = newpwd !== oldpwd
                }
            }

            copyIntoConfigsFromSections(target.configs, state.activeSystemDataEntrySectionsOriginal)
            copyIntoConfigsFromSection(target.configs, activeSection.properties)

            let newsystem = !target.id && systemInfo
            //attempt to save the changes
            let response = await SystemService.saveSystem(target, chgpwd)

            //if successful, update the original version, otherwise nothing needs to be done
            //because the original version is intact
            if (response && (response.status === 200)) {
                if ((newsystem && response.data.id) || _.isEmpty(state.activeSystemDocumentSchedules)) {
                    dispatch('getSystem', response.data.id)
                    return true
                } else {
                    if (systemInfo) {
                        commit('applyActiveSystemInfo', response.data)
                    }
                    commit('applyActiveSystemDataEntrySection', sectionId)
                    commit('setNewVersion', response.data.olv)
                }
                dispatch('status/setStatus', {inProgress: false, operation: "Infrastructure configuration changes saved", success: true, logAction: 'saving-system-configuration'}, {root: true})
                return true
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error saving infrastructure configuration changes", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-saving-system-configuration'}, {root: true})
                return false
            }
        } catch (ex) {
            dispatch('status/setStatus', {inProgress: false, operation: "Error saving infrastructure configuration changes", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-saving-system-configuration'}, {root: true})
            alert('Error saving infrastructure configuration changes ' + Common.getErrorMessage(ex))
            return false
        }

    },
    async saveActiveSystemOrgLevelConfigs( {state, dispatch, commit}, sectionId) {
        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Saving system configuration changes"}, {root: true})

            let activeSection = getters.activeSystemOrgLevelConfigSection(state)(sectionId)
            let configs = {}
            copyIntoConfigsFromSections(configs, state.activeSystemOrgLevelConfigsOriginal)
            copyIntoConfigsFromSection(configs, activeSection.properties)

            let response = await SystemService.saveOrgLevelConfigs(configs)

            if (response && (response.status === 200)) {
                dispatch('status/setStatus', {inProgress: false, operation: "Infrastructure configuration changes saved", success: true, logAction: 'saving-system-org-configs'}, {root: true})
                commit('applyActiveSystemOrgLevelConfigs', sectionId)
                return true
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error saving infrastructure configuration changes", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-saving-system-org-configs'}, {root: true})
                return false
            }
        } catch (ex) {
            dispatch('status/setStatus', {inProgress: false, operation: "Error saving infrastructure configuration changes", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-saving-system-org-configs'}, {root: true})
            alert('Error saving infrastructure configuration changes ' + Common.getErrorMessage(ex))
            return false

        }
    },
    async validateActiveSystem({ state, rootGetters, dispatch }) {
        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Validating infrastructure"}, {root: true})

            if (!state.activeSystemOriginal.id) {
                const msg = 'Please save the system before validating.'
                dispatch('status/setStatus', {inProgress: false, operation: "Cannot validate unsaved infrastructure", failure: true, message: msg, logAction: 'error-validating-system'}, {root: true})
                return {success: false, message: msg}
            }

            let response = await SystemService.validateSystemById(state.activeSystemOriginal.id, false)

            const result = Common.getValidationResult(response)

            if (result.success) {
                dispatch('status/setStatus', {inProgress: false, operation: "Infrastructure validated", success: true, logAction: 'validating-system-cca-id'}, {root: true})
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error validating infrastructure", failure: true, message: result.message, logAction: 'error-validating-system' }, {root: true})
            }

            return result

        } catch (ex) {

            let errMsg = Common.getErrorMessage(ex)
            if (ex.response && (ex.response.status === 404)) {
                errMsg = "Please make sure a collector is running" + (state.activeSystemOriginal.ccaId ? " for the assigned collecting user" : "")
            }
            console.error(ex)

            dispatch('status/setStatus', {inProgress: false, operation: "Error validating infrastructure", failure: true, message: errMsg, logAction: 'error-validating-system'}, {root: true})

            return {success: false, message: errMsg}
        }
    },
    async validateSystem({ state, rootGetters, dispatch }, system) {
        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Validating infrastructure"}, {root: true})

            let response = await SystemService.validateSystemById(system.id, false)

            const result = Common.getValidationResult(response)

            if (result.success) {
                dispatch('status/setStatus', {inProgress: false, operation: "Infrastructure validated", success: true, logAction: 'validating-system'}, {root: true})
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error validating infrastructure", failure: true, message: result.message, logAction: 'error-validating-system' }, {root: true})
            }

            return result

        } catch (ex) {

            let errMsg = Common.getErrorMessage(ex)
            if (ex.response && (ex.response.status === 404)) {
                errMsg = "Please make sure a collector is running" + (system.ccaId ? " for the assigned collecting user" : "")
            }
            console.error(ex)

            dispatch('status/setStatus', {inProgress: false, operation: "Error validating infrastructure", failure: true, message: errMsg, logAction: 'error-validating-system'}, {root: true})

            return {success: false, message: errMsg}
        }
    },
    async validateActiveSystemDataEntrySection({ state, commit, rootState, rootGetters, dispatch }, sectionId) {
        try {
            dispatch('status/setStatus', {inProgress: true, operation: "Validating infrastructure"}, {root: true})

            if (!state.activeSystemOriginal.id) {
                const msg = 'Please save the system before validating.'
                dispatch('status/setStatus', {inProgress: false, operation: "Cannot validate unsaved infrastructure", failure: true, message: msg, logAction: 'error-validating-system-section'}, {root: true})
                return {success: false, message: msg}
            }

            let response = await SystemService.validateSystemById(state.activeSystemOriginal.id, false)

            const result = Common.getValidationResult(response)

            if (result.success) {
                dispatch('status/setStatus', {inProgress: false, operation: "Infrastructure validated", success: true, logAction: 'validating-system-section'}, {root: true})
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error validating infrastructure", failure: true, message: result.message, logAction: 'error-validating-system-section' }, {root: true})
            }

            return result

        } catch (ex) {
            let errMsg = Common.getErrorMessage(ex)
            if (ex.response && (ex.response.status === 404)) {
                errMsg = "Please make sure a collector is running"+ (state.activeSystem.ccaId ? " for the assigned collecting user" : "")
            }
            console.error(ex)

            dispatch('status/setStatus', {inProgress: false, operation: "Error validating infrastructure", failure: true, message: errMsg, logAction: 'error-validating-system-section'}, {root: true})

            return {success: false, message: errMsg}
        }
    },
    async getApi({ state, rootGetters }, apiUrl) {
        try {
            let response = await SystemService.getApiUrl(state.activeSystem.id, apiUrl)
            if (response.data && response.data.includes("Error")) {
                alert(response.data)
            }
            return response.data
        } catch (e) {
            console.error(e)
            return ''
        }
    },
    async postApi({ state, rootGetters }, apiUrl) {
        try {
            let response = await SystemService.postApiUrl(state.activeSystem.id, apiUrl)
            return response.data
        } catch (e) {
            console.error(e)
            return ''
        }
    },
    async toggleEnabled ({commit, rootGetters, dispatch}, system) {
        dispatch('status/setStatus', {inProgress: true, operation: "Saving infrastructure configuration changes"}, {root: true})

        try {
            let response = await SystemService.toggleSystemEnabled(system.id, !system.pollEnabled)

            if (response && (response.status === 200)) {
                dispatch('status/setStatus', {inProgress: false, operation: "Infrastructure configuration changes saved", success: true, logAction: 'toggling-system'}, {root: true})

                system.pollEnabled = !system.pollEnabled
                commit('setNewVersion', response.data.olv)
                commit('toggleEnabled')
                return true
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error saving infrastructure configuration changes", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-toggling-system'}, {root: true})
                return false
            }
        } catch (ex) {
            dispatch('status/setStatus', {inProgress: false, operation: "Error saving infrastructure configuration changes", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-toggling-system'}, {root: true})
            alert('Error saving infrastructure configuration changes ' + Common.getErrorMessage(ex))
            return false
        }
    },
    async repoll({}, {collectorId, collectorName, systemId}) {
        try {
            let response = await CollectorService.repoll(collectorId, collectorName, systemId)

            if (response && (response.status === 200)) {
                return response.data
            } else {
                return "Error: " + response.status
            }
        } catch (ex) {
            return "Error: " + Common.getErrorMessage(ex)
        }
    },
    async getExtraConfigValueForKey({}, key) {       
        let response = await SystemService.getExtraConfigValueForKey(key)
        return response.data
    },
    async getExtraConfigValues() {
       let response =  await SystemService.getExtraConfigValues()
       return response.data
    },
    async saveExtraConfigValuesStr({dispatch}, configs) {

        dispatch('status/setStatus', {inProgress: true, operation: "Saving extra configs"}, {root: true})

        try {
            let response =  await SystemService.saveExtraConfigsStr(configs)

            if (response && (response.status === 200)) {
                dispatch('status/setStatus', {inProgress: false, operation: "Extra configs saved", success: true, logAction: 'extra-configs'}, {root: true})
                return true
            } else {
                dispatch('status/setStatus', {inProgress: false, operation: "Error saving extra configs", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-extra-configs'}, {root: true})
                return false
            }
        } catch (ex) {
            dispatch('status/setStatus', {inProgress: false, operation: "Error saving extra configs", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-extra-configs'}, {root: true})
            alert('Error saving extra configs ' + Common.getErrorMessage(ex))
            return false
        }

    }, 
    async getAllTypeCodes({commit, state}) {
        let response =  await SystemService.getAllTypeCodes();
        commit('setAllTypeCodes', _.sortBy(response.data))
        return response.data
    },
    async getAllowedTypes() {
        let response =  await SystemService.getAllowedTypes()
        return response.data
     },
     async saveAllowedTypes({dispatch}, allowedTypes) {
 
         dispatch('status/setStatus', {inProgress: true, operation: "Saving allowed types"}, {root: true})
 
         try {
             let response =  await SystemService.saveAllowedTypes(allowedTypes)
 
             if (response && (response.status === 200)) {
                 dispatch('status/setStatus', {inProgress: false, operation: "Allowed types saved", success: true, logAction: 'allowed-types'}, {root: true})
                 return true
             } else {
                 dispatch('status/setStatus', {inProgress: false, operation: "Error saving allowed types", failure: true, message: (response.status + ' ' + response.statusText), logAction: 'error-allowed-types'}, {root: true})
                 return false
             }
         } catch (ex) {
             dispatch('status/setStatus', {inProgress: false, operation: "Error saving allowed types", failure: true, message: Common.getErrorMessage(ex), logAction: 'error-allowed-types'}, {root: true})
             alert('Error saving allowed types ' + Common.getErrorMessage(ex))
             return false
         }
 
     }, 
    async getDeletedSystems() {
        let response = await SystemService.getSystems(true)
        return response.data
    },
    async unDeleteSystem({}, id) {
        let response = await SystemService.unDeleteSystem(id)
        return response.status === 200
    },
    async unDeleteMultipleSystems({}, systems) {
        const patchlist = _.map(systems, (sys) => { return {id: sys.id, deleted: false}})
        let response = await SystemService.patchMultiple(patchlist)
        return response.status === 200
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
